import Modal from "components/atoms/modal";
import { H4, TextSm } from "components/atoms/text";
import Btn from "components/atoms/buttons";

interface Props {
  onClick: () => void;
}

// 비밀번호 변경 성공 모달
const ModalComplete = ({ onClick }: Props) => {
  return (
    <Modal.Container className="w-[312px] p-10 rounded-16 text-center">
      <H4 className="mb-3">비밀번호 재설정</H4>
      <TextSm className="text-black-60% mb-5">
        패스워드가 변경되었습니다.
      </TextSm>
      <Btn.Blue onClick={onClick} size="large" className="w-full">
        확인
      </Btn.Blue>
    </Modal.Container>
  );
};

export default ModalComplete;
